var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c(
        "div",
        {
          class: [_vm.onecode == 1 ? "form-group" : "form-group xinzeng"],
          on: {
            click: function($event) {
              return _vm.clickTiao(_vm.onecode, _vm.Barcode)
            }
          }
        },
        [
          _c("img", { staticClass: "img", attrs: { id: "barcode" } }),
          _vm._v(" "),
          _vm.onecode === 1 ? _c("div", { attrs: { id: "qrcode" } }) : _vm._e(),
          _vm._v(" "),
          _c("span", { class: [_vm.onecode == 1 ? "smallNum" : "bigNum"] }, [
            _vm._v(_vm._s(_vm.onecode == 1 ? _vm.codeTextpass : _vm.codeText))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.onecode == 1,
              expression: "onecode == 1"
            }
          ]
        },
        [
          _c("p", { staticClass: "add_warn" }, [
            _vm._v("动态码定时更新，请勿截屏，以免影响正常使用")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "lines" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "moneys" },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("p", { staticClass: "money_has" }, [_vm._v("余额")]),
                _vm._v(" "),
                _c("p", { staticClass: "money_num" }, [
                  _vm._v("￥" + _vm._s(_vm.moneyNum))
                ])
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "money_save", attrs: { to: "/Recharge" } },
                [_vm._v("充值")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-577b45f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577b45f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/longcode.vue
// module id = null
// module chunks = 